export default function changeLang() {
    const changeLangElement = document.getElementById("changeLang");
    const langFunctionElement = document.getElementById("langFunction");
    const routeCurrentElement = document.getElementById("routeCurrent");

    if (changeLangElement && langFunctionElement && routeCurrentElement) {
        changeLangElement.addEventListener("change", function () {
            const lang = changeLangElement.value;
            const url = langFunctionElement.value;

            fetch(url, {
                method: "POST",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ lang: lang }),
            })
            .then(async (response) => {
                if (!response.ok) {
                    if (response.status === 419) {
                        alert("Sessão expirada. A página será recarregada.");
                        location.reload();
                        return;
                    }

                    const responseText = await response.text();
                    console.error(`Erro HTTP ${response.status}:`, responseText);
                    return;
                }

                return response.json();
            })
            .then((data) => {
                if (!data) return;

                if (data.status) {
                    const urlCurrent = routeCurrentElement.value;
                    window.location.replace(urlCurrent);
                } else {
                    console.error("Falha ao trocar idioma:", data);
                }
            })
            .catch((error) => {
                console.error("Erro na requisição de troca de idioma:", error);
            });

        });
    }
}
